import * as React from 'react'
import Form, { FormComponentProps } from 'antd/lib/form'
import { Input, Icon, Button, InputNumber } from 'antd'
import { CreateInvoiceLine, IBatchInInvoiceLine } from '@getgreenline/homi-shared'

interface Props extends FormComponentProps {
  className?: string
  product: CreateInvoiceLine
}

class HorizontalLoginForm extends React.Component<Props, {}> {
  componentDidMount = () => {
    // To disable submit button at the beginning.
    this.props.form.validateFields()
  }

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { form, product } = this.props

    form.validateFields((err, values: IBatchInInvoiceLine) => {
      if (err) {
        return
      }

      values.batchNumber = values.batchNumber.trim()

      product.addBatch({ ...values })

      form.resetFields()
    })
  }

  hasErrors = (fieldsError: Record<string, string[] | undefined>) => {
    return Object.keys(fieldsError).some((field) => fieldsError[field])
  }

  hasError = (decorator: string): false | string[] | undefined => {
    // Only show error after a field is touched.
    const { getFieldError, isFieldTouched } = this.props.form
    return isFieldTouched(decorator) && getFieldError(decorator)
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form

    return (
      <Form className={this.props.className} layout='inline' onSubmit={this.handleSubmit}>
        <Form.Item
          validateStatus={this.hasError('batchNumber') ? 'error' : ''}
          help={this.hasError('batchNumber') || ''}
        >
          {getFieldDecorator('batchNumber', {
            rules: [{ required: true, message: 'Please input the lot number.' }],
          })(<Input placeholder='Lot number' />)}
        </Form.Item>
        <Form.Item
          style={{ minWidth: 150 }}
          validateStatus={this.hasError('quantity') ? 'error' : ''}
          help={this.hasError('quantity') || ''}
        >
          {getFieldDecorator('quantity', {
            rules: [{ required: true, message: 'Please input the quantity.' }],
          })(<InputNumber min={0} style={{ minWidth: 150 }} placeholder='Quantity' />)}
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' disabled={this.hasErrors(getFieldsError())}>
            Add
          </Button>
        </Form.Item>
      </Form>
    )
  }
}

export const BatchAddForm = Form.create<Props>({ name: 'horizontal_lot_form' })(HorizontalLoginForm)
